@use "@fukuri-admins/ui/layout" as *;

.SideMenu {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: $SideMenuWidth;
  background-color: $White;
  border-right: 1px solid border("Tertiary");
  height: 100vh;
  z-index: 10;
  @media screen and (max-width: $TB) {
    flex-direction: row;
    gap: 16px;
    width: 100%;
    height: auto;
    padding: 16px;
  }
}
